<template>
  <div class='price'>
    <h3>公有云部署</h3>
    <p>0启动成本。单价行业内最低！小程序端限免！</p>
    <h3>私有化部署</h3>
    <p style='margin-bottom: 40px'>请联系 400-646-1860 获取详细报价</p>
    <normal-button @click='handleExperienceClick'>立即体验</normal-button>
  </div>
</template>

<script>
import NormalButton from '../../../components/normal_button.vue';
import { CONSOLE_SITE_URL } from '../../../utils/constants';

export default {
  name: 'Price',
  components: {
    NormalButton,
  },
  methods: {
    handleExperienceClick() {
      window.open(CONSOLE_SITE_URL);
    }
  },
}
</script>

<style lang="less" scoped>
.price {
  text-align: center;
  padding: 10px 0;
  h3 {
    font-size: 30px;
    color: #333333;
  }
  p {
    font-size: 21px;
    color: #808080;
    margin-top: 6px;
    margin-bottom: 24px;
  }
}
</style>
